import { getTNDSInsPrice, getInsurancePrice } from "../model/insurance";

export const getTNDSInsurancePrice = (data) => {
	return {
			type: "GET_TNDS_PRICE",
			payload: getTNDSInsPrice(data)
	}
}

export const getInsPrice = (data) => {
	return {
		type: "GET_INS_PRICE",
		payload: getInsurancePrice(data)
	}
}
